import { BloodIndentReturnDetails } from './BloodIndentReturnDetails';
import { Parameter } from './../../../../@core/interfaces/common/parameter';
import { Observable } from 'rxjs';

export interface BloodIndentReturnHeaderParameter extends Parameter {
  searchTerm: number;
  orderBy: string;
}

export interface BloodIndentReturnHeader {
BlIndentReturnMstId:number;
BlIndentReturnDate:any;
BlReturnedBy:string;
BlSenderTenantId:string;
BlSenderBranchId:string;
BlReceiverTenantId:string
BlReceiverBranchId:string;
BlReceiverDepartmentId:number;
BlInternalDepartmentId:number;
TenantId:string;
BranchId:string;
CreatedDate:any;
CreatedIP:any;
CreatedBy:any;
IndentReturnDetail: BloodIndentReturnDetails[];
}

export abstract class BloodIndentReturnHeaderData {
  abstract list(url: string): Observable<any[]>;
  abstract getById(url: string): Observable<any>;
  abstract searchList(url: string,data:any): Observable<any>;
  abstract create(url: string,data: any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}

